import { Routes } from '@angular/router';
import { ServerMaintenancePageComponent } from './server-maintenance-page/server-maintenance-page.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

export const routes: Routes = [
  { path: 'server-under-maintenance', component: ServerMaintenancePageComponent },
  { path: 'page-not-found', component: PageNotFoundComponent },
];
